const BRANDED_APPS_URL = '/get-branded-apps';

module.exports = {

    getBrandedApps: function getBrandedApps(company_id) {
        return window.axios.get(BRANDED_APPS_URL, { params:
                {
                    company_id: company_id,
                }
        });
    }
};
